import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useQueryClient } from "@tanstack/react-query";
import { Chips, Empty, Loading, fmtWhen, useAdmin } from "./ui";
import { DataTools, RowDelete } from "./DataTools";

const KIND = (k) => (k.startsWith("spa_") ? "To spa" : "To client") + " · " + k.split("_").slice(1).join(" ");

export const EmailLog = () => {
  const { data } = useAdmin("messages", "/admin/messages");
  const [filter, setFilter] = useState("all");
  const [open, setOpen] = useState(null);
  const qc = useQueryClient();
  const refresh = () => qc.invalidateQueries({ queryKey: ["admin", "messages"] });
  const shown = (data || []).filter((m) => filter === "all" || (filter === "failed" ? m.status === "failed" : m.kind.startsWith(filter)));
  return (
    <div data-testid="email-log">
      <DataTools section="messages" label="sent emails" exportUrl="/admin/messages/export" filename="waxmoi-emails-sent.xlsx" onPurged={refresh} />
      <Chips options={[["all", "All"], ["spa", "To spa"], ["client", "To clients"], ["failed", "Failed"]]} value={filter} onChange={setFilter} testPrefix="messages-filter" />
      {!data ? <Loading /> : shown.length === 0 ? <Empty>No messages yet.</Empty> : (
        <div className="ad-table">
          {shown.map((m) => (
            <button className="ad-trow ad-trow-btn" key={m.id} onClick={() => setOpen(m)} data-testid={`message-row-${m.id}`}>
              <div><strong>{m.subject}</strong><small>{m.to}</small></div>
              <div><small>{KIND(m.kind)}</small><small>{fmtWhen(m.created_at)}</small></div>
              <div className="ad-tright"><span className={`pill msg-${m.status}`} data-testid="message-status">{m.status}</span></div>
            </button>
          ))}
        </div>
      )}
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="ad-msg-dialog" data-testid="message-dialog">
          {open && (
            <>
              <DialogTitle className="ad-msg-title">{open.subject}</DialogTitle>
              <p className="muted-sm">To {open.to} · {fmtWhen(open.created_at)}</p>
              {open.error && <p className="form-error">{open.error}</p>}
              <RowDelete url={`/admin/messages/${open.id}`} name="this email from the log" onDone={() => { setOpen(null); refresh(); }} testId="message-delete-button" />
              <iframe title="Email preview" className="ad-msg-frame" sandbox="" srcDoc={open.html} />
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
